import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 text-base leading-normal"
}
const _hoisted_2 = ["value", "disabled", "aria-disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(_ctx.classes)
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({ value: _ctx.value }, _ctx.$attrs, {
      disabled: _ctx.disabled,
      "aria-disabled": _ctx.disabled,
      type: "file",
      id: "inputFile",
      class: "hidden",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFile($event))),
      multiple: ""
    }), null, 16, _hoisted_2)
  ], 2))
}